<template>
  <div class="btn-wrapper">
    <RouterLink
      v-if="hasRouteName"
      :to="{ name: routeName, params: routeParams }"
      :data-test="`${dataTest}-button`"
    >
      <button
        :class="theme"
        class="btn"
      >
        <span class="btn-text">
          {{ text }}
        </span>
      </button>
    </RouterLink>

    <button
      v-if="!hasRouteName"
      :class="cssClasses()"
      class="btn"
      type="submit"
      :data-test="`${dataTest}-button`"
      @click="click"
    >
      <span class="btn-text">
        {{ text }}
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'Btn',
  props: {
    routeName: {
      type: String,
      default: null,
    },
    routeParams: {
      type: Object,
      default() { return {} },
    },
    text: {
      type: String,
      default: '',
    },
    dataTest: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasRouteName () {
      return !!this.routeName
    },
  },
  methods: {
    cssClasses() {
      return {
        [this.theme]: true,
        active: this.active,
      }
    },
    click () {
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss">
  @import "styles/index";
</style>
